import React from 'react';
import './dangerousGoodsIcon.scss';
import {
	DangerousGoodsModel,
} from 'models';

interface Props {
	className?: string;
	dangerousGoods: DangerousGoodsModel;
	length?: number;
	fontSize?: string;
	done?: boolean;
}

export const DangerousGoodsIcon = ({
	className,
	dangerousGoods,
	length,
	fontSize = '16px',
	done = false,
}: Props) => (
	<div
		className={`dangerous-goods icon-container ${className || ''}`}
		style={{
			fontSize,
		}}
	>
		<div className={'top pill' + (done ? ' done' : '')}>
			<div className="code">
				{length && length > 1 ? '' : dangerousGoods.hazardIdentificationNumber}
			</div>
		</div>
		<div className={'bottom pill' + (done ? ' done' : '')}>
			<div className="code">
				{length && length > 1 ? '' : dangerousGoods.unno}
			</div>
		</div>
	</div>
);